import { ref, computed } from 'vue'
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useGlobalStore } from '@/stores/global'

import { format } from 'date-fns'
import { nl } from 'date-fns/locale' // Import Dutch locale

export const isAuthenticated = computed(() => useAuthenticationData().data.value.isAuthenticated)

export const resolveEnum = (val: string) => {
  const globalStore = useGlobalStore()

  const enums = globalStore.getEnumLookup

  if (enums && enums.length > 0) {
    const enumFilter = enums.filter((item: any) => item.id === val)

    if (enumFilter && enumFilter.length > 0) {
      return enumFilter[0].enumValue
    }
  }

  return ''
}

export const resolveCustomerGroup = (val: string | string[], type: string) => {
  const globalStore = useGlobalStore()

  const list = globalStore.getCustomerGroupLookup

  if (list && list.length > 0) {
    const listFilter = Array.isArray(val)
      ? list.filter((item) => val.includes(item.id))
      : list.filter((item) => item.id === val)

    if (listFilter && listFilter.length > 0) {
      if (type == 'array') {
        return Array.isArray(val) ? listFilter : listFilter
      } else {
        return listFilter[0]
      }
    }
  }

  return ''
}

export const resolveHoursAndMinutesFormat = (ms: number) => {
  if (ms) {
    const padTo2Digits = (num: number) => {
      return num.toString().padStart(2, '0')
    }

    let seconds = Math.floor(ms / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)

    seconds = seconds % 60
    // minutes = seconds >= 30 ? minutes + 1 : minutes
    minutes = minutes % 60
    hours = hours % 24

    if (hours > 0) {
      return `${padTo2Digits(hours)}u ${padTo2Digits(minutes)}m`
    } else {
      return `${padTo2Digits(minutes)}m`
    }
  } else {
    return ''
  }
}

export const resolveToClockDuration = (ms: number) => {
  if (ms) {
    const padTo2Digits = (num: number) => {
      return num.toString().padStart(2, '0')
    }

    let seconds = Math.floor(ms / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)

    seconds = seconds % 60

    minutes = minutes % 60

    hours = hours % 24

    if (hours > 0) {
      return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`
    } else {
      return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`
    }
  } else {
    return ''
  }
}

export const resolveDateFormat = (date: string) => {
  let initialDate = date

  //Timezone offset
  let hrs = -(new Date().getTimezoneOffset() / 60)

  const months = [
    'Jan.',
    'Feb.',
    'Mar.',
    'Apr.',
    'May.',
    'June.',
    'Jul.',
    'July.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.'
  ]

  let d = new Date(initialDate)

  const addZero = (i: any) => {
    if (i < 10) {
      i = '0' + i
    }

    return i
  }

  const monthIndex = d.getMonth()
  const monthName = months[monthIndex]
  const year = d.getFullYear()
  const day = d.getDate()
  const hours = addZero(d.getHours() + hrs)
  const minutes = addZero(d.getMinutes())

  return day + ' ' + monthName + ' ' + year + ' ' + hours + ':' + minutes
}

export const returnDateWithFormat = (dateString: string, dateFormat: string) => {
  const date = new Date(dateString)
  const timezoneOffset = date.getTimezoneOffset()

  if (timezoneOffset <= 0) {
    date.setMinutes(date.getMinutes() - timezoneOffset)
  } else {
    date.setMinutes(date.getMinutes() + timezoneOffset)
  }

  return format(date, dateFormat, { locale: nl })
}

export const pluckField = (fArray: Array<any>, fString: string) => {
  return fArray
    .flat()
    .map((content) => content?.[fString])
    .filter((item) => item)
}

export const resolveStringReplace = (fVal: string) => {
//   if (fVal == 'Exercises') {
//     return 'All exercises'
//   } else if (fVal == 'Categories') {
//     return 'All categories'
//   } else if (fVal == 'Level') {
//     return 'All levels'
//   } else if (fVal == 'Skills') {
//     return 'All skills'
//   } else if (fVal == 'Main Categories') {
//     return 'All Categories'
//   } else if (fVal == 'Classes') {
//     return 'All classes'
//   } else {
    return fVal
  //}
}